import { render, staticRenderFns } from "./InvoicePayFailure.vue?vue&type=template&id=64cc0222"
import script from "./InvoicePayFailure.vue?vue&type=script&lang=js"
export * from "./InvoicePayFailure.vue?vue&type=script&lang=js"
import style0 from "./InvoicePayFailure.vue?vue&type=style&index=0&id=64cc0222&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports